export const loadReCaptchaScript = () => {
    const SCRIPT_ID = 'recaptcha';
    const existingScript = document.getElementById(SCRIPT_ID);
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?onload=onGCaptchaLoad&render=explicit';
        script.async = true;
        script.defer = true;
        script.id = SCRIPT_ID;
        document.body.appendChild(script);
    }
};



// WEBPACK FOOTER //
// ./src/utils/loadReCaptchaScript.js